module.exports = __webpack_public_path__ + "assets/img/sukikamolist_tittle.9e211e67.svg";